import React, { createContext, useState, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [colors] = useState({
    primary: '#d92231',
    secondary: '#ffffff',
    text: '#000000'
  });
  
  const [backgroundImage, setBackgroundImage] = useState(
    'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=1920&h=1080&fit=crop'
  );
  
  return (
    <ThemeContext.Provider value={{ colors, backgroundImage, setBackgroundImage }}>
      {children}
    </ThemeContext.Provider>
  );
};
